import { Component, Input, OnInit } from "@angular/core";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { CommonModule } from "@angular/common";
import { PowertrainModalComponent } from "../powertrain-modal/powertrain-modal.component";
import { MatButton, MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-powertrain-flase-claims",
  templateUrl: "./powertrain-flase-claims.component.html",
  styleUrls: ["./powertrain-flase-claims.component.scss"],
  standalone: true,
  imports: [CommonModule,PowertrainModalComponent,MatButtonModule],
})
export class PowertrainFlaseClaimsComponent implements OnInit {
  powertrainFalseClaimsUrl =
    BaseUrlConstantsService.POWERTRAIN_FLASE_CLAIMS_API;
  false_Claims_metrics: any = {
    positives: "N/A",
    negatives: "N/A",
    uptime: "N/A",
    subsystem_id: "N/A",
    client_id: "N/A",
  };
  false_Claims_metrics_loader: boolean = true;

  @Input("subsystem_id") subsystemId!: number | string;
  @Input("client_id") client_id: string | number;

  showModal: boolean = false;

  constructor(
    private service: PowerTrainService,
    private spinner: BackendApiService
  ) {}

  ngOnInit(): void {
    this.fetchFalseClaimsMetrics();
  }

  fetchFalseClaimsMetrics() {
    this.service
      .fetchPowertrainFalseClaims(
        this.powertrainFalseClaimsUrl + this.subsystemId
      )
      .then((falseClaimsRes: any) => {
        this.false_Claims_metrics = {
          positives: falseClaimsRes.positives + "%",
          negatives: falseClaimsRes.negatives + "%",
          uptime: Math.floor(falseClaimsRes.uptime) + "%",
          subsystem_id: this.subsystemId,
          client_id: this.client_id,
        };
      })
      .catch((error) => {
        // this.spinner.showError("Failed to fetch False claims metrics");
        this.false_Claims_metrics = {
          positives: "N/A",
          negatives: "N/A",
          uptime: "N/A",
          subsystem_id: this.subsystemId,
          client_id: this.client_id,
        };
      })
      .finally(() => {
        this.false_Claims_metrics_loader = false;
      });
  }

  updateFalseClaimsMetrics() {
    this.showModal = true;
  }
  closeBox(data: any) {
    this.showModal = false;

    if (data?.updatedData) {
      this.false_Claims_metrics.positives = data.updatedData.positives + "%";
      this.false_Claims_metrics.negatives = data.updatedData.negatives + "%";
      this.false_Claims_metrics.uptime =
        Math.floor(data.updatedData.uptime) + "%";
    }
  }
}
